<template>
  <section id="conference">
    <div class="container container-one">
      <div class="heading">
        <h1>
          Dev, Design & Tech
          <span>konferencija</span>
        </h1>
        <p>DUMP Days već četvrtu godinu za redom okuplja hrvatsku IT zajednicu i nudi bezbroj prilika za razmjenu znanja i iskustva te stvaranje novih poslovnih veza.</p>
      </div>
      <div class="list list-one">
        <Feature
          :feature="{
        backgroundColor: '#30CEC1',
        icon: 'whiteboard',
        subtitle: '',
        title: 'Predavanja',
        description: 'Poslušaj zanimljiva predavanja stručnjaka o aktualnim Dev, Design & Tech temama.'
      }"
        />
        <Feature
          :feature="{
        backgroundColor: '#30CEC1',
        icon: 'stats',
        subtitle: '',
        title: 'Radionice',
        description: 'Stekni uvid u najnovije tehnologije kroz praktičan rad na radionicama koje vode stručnjaci iz industrije.'
      }"
        />
        <Feature
          :feature="{
        backgroundColor: '#2C373F',
        icon: 'table',
        subtitle: '',
        title: 'Panel rasprave',
        description: 'U moderiranim raspravama poslušaj različita mišljenja profesionalaca o zanimljivim temama iz svijeta IT-ja.'
      }"
        />
      </div>
    </div>
    <img class="visual visual-one" src="../../assets/visuals/one.png" alt="Predavanje">
    <div class="black">
      <div class="list list-two container">
        <Feature
          :feature="{
        backgroundColor: '#30CEC1',
        icon: 'tent',
        subtitle: '',
        title: 'Campfire talks',
        description: 'Budi dio “panela u malom” i zajedno sa sponzorima konferencije sudjeluj u raspravama u nesvakidašnjoj atmosferi.'
      }"
        />
        <Feature
          :feature="{
        backgroundColor: '#30CEC1',
        icon: 'games',
       subtitle: '',
        title: 'Fly talks',
        description: 'Tražiš posao? Kroz kratke jedan na jedan razgovore s poslodavcima saznaj jesi li upravo ti ono što traže.'
      }"
        />
      </div>
    </div>
    <img class="visual visual-two" src="../../assets/visuals/two.png" alt="Druženje">
    <div class="container">
      <div class="list list-three">
        <Feature
          :feature="{
        backgroundColor: '#30CEC1',
        icon: 'network',
        subtitle: '',
        title: 'Networking',
        description: 'Kroz opušteni razgovor saznaj sve što te zanima, upoznaj istomišljenike i podijeli svoje interese, iskustva i ideje.'
      }"
        />
        <Feature
          :feature="{
        backgroundColor: '#30CEC1',
        icon: 'plans',
        subtitle: '',
        title: 'Izložbeni prostor',
        description: 'Sumo borbe, VR, tehnološka alka, craft pivo… Prošetaj štandovima tvrtki i pogledaj što sve imaju za ponuditi.'
      }"
        />
        <Feature
          :feature="{
        backgroundColor: '#30CEC1',
        icon: 'balloons',
        subtitle: '',
        title: 'Nagrade',
        description: 'Pokaži svoju spretnost u ispunjavanju zadataka i osvoji nagrade poput PlayStationa 4, HTC Vivea i putovanja po Europi.'
      }"
        />
      </div>
    </div>
  </section>
</template>

<style scoped>
.list {
  display: flex;
  flex-direction: column;
}

.visual-two {
  margin-left: auto;
  margin-right: 0;
  display: table;
}
.black {
  margin-top: -185px;
  margin-bottom: -130px;
  padding-top: 230px;
  padding-bottom: 120px;
  background-color: #2c373f;
  background-image: url("../../assets/patterns/visual-identity.png");
}

.black .feature {
  color: #fff;
}
.visual {
  width: 100%;
  max-width: 375px;
}
.heading {
  margin-top: 85px;
  margin-bottom: 90px;
}
h1 {
  color: #30cec1;
  font-family: "Fuse V.2 Display";
  font-size: 34px;
  letter-spacing: -0.17px;
  line-height: 40px;
  font-weight: bold;
}
h1 span {
  color: #000;
  display: table;
}

p {
  margin-top: 15px;
  color: rgba(0, 0, 0, 0.75);
  font-family: "Fuse V.2 Display";
  font-size: 16px;
  line-height: 28px;
}

@media screen and (min-width: 480px) {
  .visual {
    max-width: 70%;
  }

  .list .feature:nth-of-type(2) {
    align-self: center;
  }

  .list .feature:last-of-type {
    align-self: flex-end;
  }

  .visual-one {
    margin-top: -200px;
  }

  .list-three {
    margin-top: -150px;
  }
}

@media screen and (min-width: 768px) {
  .list .feature:nth-of-type(2),
  .list .feature:last-of-type {
    align-self: initial;
  }

  .black {
    margin-top: -285px;
  }

  .container {
    display: flex;
  }

  .container-one {
    display: block;
  }

  .heading {
    max-width: 585px;
    margin-top: 180px;
    width: 80%;
  }

  .list-one {
    width: 75%;
    max-width: 585px;
    margin-left: auto;
    margin-right: 0;
    padding-left: 55px;
  }

  .visual-one {
    margin-top: -25vw;
  }

  h1 {
    font-size: 56px;
    letter-spacing: -0.26px;
    line-height: 60px;
  }

  p {
    font-size: 18px;
    line-height: 32px;
  }

  .list-two {
    flex-direction: row;
    justify-content: space-between;
  }

  .list-three {
    margin-left: 0;
    margin-right: auto;
    max-width: 50%;
  }

  .visual {
    max-width: 100%;
  }
}

@media screen and (min-width: 1024px) {
  .visual {
    max-width: 1000px;
  }

  .black {
    margin-top: -400px;
    padding-top: 400px;
    padding-bottom: 300px;
    margin-bottom: -250px;
  }

  .heading {
    max-width: 50%;
  }

  .list-one {
    margin-top: -50px;
    margin-bottom: -200px;
  }

  .list-three {
    margin-top: -700px;
    margin-bottom: 150px;
  }
}
</style>

<script>
import Feature from "@/components/landing-page/Feature.vue";

export default {
  name: "HeaderHero",
  components: {
    Feature
  }
};
</script>
